export const DEFAULT_COLOR = '#4fa94d';

export const DEFAULT_WAI_ARIA_ATTRIBUTE = {
    'aria-busy': true,
    role: 'progressbar',
};
